import { styled } from '@/shared/ui';
import { NavLink } from '@/shared/ui/NavLink';

export const StyledNavigationLink = styled(NavLink)(() => ({
  textDecoration: 'none',
  color: 'inherit',
  cursor: 'default',

  ':active': {
    color: 'inherit',
  },

  ':hover': {
    color: 'inherit',
  },
}));
